import { useEffect, useState } from "react";
import api from "../../services/api";
import Param from "../../models/Param";

interface Params {
  afterSelect: (id: number) => void;
}

const CongregationSelect = ({ afterSelect }: Params) => {
  const [congregations, setCongregations] = useState<Param[]>([]);
  const [congSearch, setCongSearch] = useState<number>(0);

  useEffect(() => {
    const init = async () => {
      const { data } = await api.get("congregations/dashboard");
      setCongregations(data);
    };
    
    init();
  }, []);

  return <div className="uk-width-1-1@m">
      <label
        className="uk-form-label uk-margin-right"
        htmlFor="congregation"
      >
        Congregação
      </label>
      <div
        uk-form-custom="target: > * > span:first-child"
        className="uk-width-1-2@m"
      >
        <select
          className="uk-form-small"
          id="congregation"
          name="congregation"
          value={congSearch}
          onChange={(e) => { setCongSearch(+e.target.value); afterSelect(+e.target.value); }}
        >
          <option value="" key={`congregation0`}>
            Todas
          </option>
          {congregations.map((f) => {
            return (
              <option value={f.id} key={`congregation${f.id}`}>
                {f.description}
              </option>
            );
          })}
        </select>
        <button
          className="uk-button uk-button-default uk-button-select uk-form-small uk-width-1 uk-flex uk-flex-middle uk-flex-between"
          style={{ textTransform: "none" }}
          type="button"
          tabIndex={-1}
        >
          <span></span>
          <span uk-icon="icon: chevron-down"></span>
        </button>
      </div>
    </div>
};

export default CongregationSelect;